import React from "react";
import { render } from "react-dom";

import * as serviceWorker from "./serviceWorker";

import "./assets/styles.css";

import { SnackbarProvider } from "notistack";

import Slide from "@mui/material/Slide";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  primary: {
    // light: will be calculated from palette.primary.main,
    main: "#00465c",
    // dark: will be calculated from palette.primary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
  },

  palette: {
    primary: {
      main: "#00465c",
    },
    secondary: {
      main: "#9bd0b0",
    },
    neutral: {
      main: "#5c6ac4",
    },
    orange: {
      main: "#ff9800",
    },
    green: {
      main: "#4caf50",
    },
    red: {
      main: "#f44336",
    },
    white: {
      main: "#fff",
    },
    accent: {
      main: "#16ac70",
    },
    default: {
      main: "#d9d9d9",
    },
  },
  MuiSelect: {
    defaultProps: {
      variant: "standard",
    },
  },
  components: {
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
    },
  },
});

import App from "./App";

render(
  <SnackbarProvider
    hideIconVariant={true}
    maxSnack={3}
    anchorOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    TransitionComponent={Slide}
  >
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </SnackbarProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
